import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from '@gympass/yoga'
import { useHistory } from 'react-router-dom'
import { Logo } from '@assets/logos'
import useDataLayer from '@hooks/useDataLayer'
import useRouteBuilder from '@hooks/useRouteBuilder'
import { FixedBarWrapper, GympassLogo } from './FixedBar.style'

export default function FixedBar() {
  const [fixed, setFixed] = useState(false)
  const [visible, setVisible] = useState(false)
  const { events, values } = useDataLayer()
  const history = useHistory()
  const { buildRoute } = useRouteBuilder()

  const handleSubmit = () => {
    events.simulatorInteraction(values.TOP_BAR_BUTTON)
    history.push(buildRoute('simulate/company-info'))
  }

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset > 534) {
        setFixed(true)
        setVisible(true)
      } else {
        setFixed(false)
        setVisible(false)
      }
    }
  })

  return (
    visible && (
      <FixedBarWrapper fixed={fixed}>
        <GympassLogo src={Logo} alt="Logo do Gympass escrito em laranja" />
        <Button onClick={handleSubmit}>
          <FormattedMessage id="smb_acquisition_home.lead_capture.call_to_action.default" />
        </Button>
      </FixedBarWrapper>
    )
  )
}
